import { isCartLineOfferDisplayRole } from "../../Promotion/utils/promotionOfferProductsShared";

export const isTelecallerUser = () => localStorage.getItem("user_role") === "20";

export const getTelecallerMaxAvailableQty = (item) => {
  if (!item) return null;
  const orderTypeRaw = String(item.order_type || item.type || "Box").trim().toLowerCase();
  const isPiece =
    orderTypeRaw === "piece" ||
    orderTypeRaw === "p" ||
    orderTypeRaw === "1";
  const raw = isPiece
    ? (item.availablePieceQty ?? item.available_piece_qty)
    : (item.availableBoxQty ?? item.available_box_qty);
  if (raw === undefined || raw === null || raw === "") return null;
  const n = parseFloat(raw);
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
};

export const shouldSkipTelecallerStockLimit = (item) => {
  if (!item) return true;
  return isCartLineOfferDisplayRole(item);
};

export const getTelecallerProductDisplayName = (item) => {
  if (!item) return "Product";
  return (
    item.desc ||
    item.name ||
    item.product_name ||
    item.productName ||
    "Product"
  );
};

export const parseAvailableQuantityStockMessage = (message) => {
  if (!message || typeof message !== "string") return null;
  const normalized = message.replace(/\*\*/g, "").trim();
  const re =
    /^Available quantity of\s+(.+?)\s+is\s+(\d+(?:\.\d+)?)\s+only\.?\s*So can add maximum\s+(\d+(?:\.\d+)?)(?:\s*qty)?\.?$/i;
  const m = normalized.match(re);
  if (!m) return null;
  const productName = m[1].trim();
  const availableQty = parseFloat(m[2]);
  const maxQty = parseFloat(m[3]);
  if (!Number.isFinite(availableQty) || !Number.isFinite(maxQty)) return null;
  return { productName, availableQty, maxQty };
};
